import { render } from "./CountryManagement.vue?vue&type=template&id=3bec8c79&scoped=true"
import script from "./CountryManagement.vue?vue&type=script&lang=js"
export * from "./CountryManagement.vue?vue&type=script&lang=js"

import "./CountryManagement.vue?vue&type=style&index=0&id=3bec8c79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bec8c79"],['__file',"src/views/CountryManagement/CountryManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bec8c79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bec8c79', __exports__)) {
    api.reload('3bec8c79', __exports__)
  }
  
  module.hot.accept("./CountryManagement.vue?vue&type=template&id=3bec8c79&scoped=true", () => {
    api.rerender('3bec8c79', render)
  })

}


export default __exports__